// initial state
const state = {
  options: {
    status: [
      {label: '新创建', value: 1},
      {label: '待审批', value: 2},
      {label: '已通过', value: 3},
      {label: '已驳回', value: 4},
    ],
    approveStatus: [
      {label: '新创建', value: 0},
      {label: '待审批', value: 1},
      {label: '已通过', value: 2},
      {label: '已驳回', value: 3},
    ]
  },
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const executiveBudget = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/executive-budget/executive-budget.store.js